"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var typings_1 = require("../typings");
var errors_1 = require("../helpers/errors");
var Baobab_EventConstruct_1 = require("./Baobab-EventConstruct");
exports.SCHEMA_VER = 0;
var Logger = (function () {
    function Logger(_a, Sender) {
        var _this = this;
        var prefix = _a.prefix, senderParams = _a.senderParams;
        this.nextEventId = 0;
        this.nextNodeId = 0;
        this.rootNodes = [];
        this.listeners = {
            createnode: [],
            removenode: [],
            actionnode: [],
        };
        this.childrenCreatedPerLoop = {};
        this.resolveEvent = function () { _this.actualEvent = undefined; };
        this.baobabSender = new Sender(senderParams);
        this.prefix = prefix;
    }
    Logger.prototype.getRootNodes = function () {
        return this.rootNodes;
    };
    Logger.prototype.getRootSendNodes = function () {
        var _this = this;
        return this.rootNodes.map(function (node) { return _this.encodeNode(node); });
    };
    Logger.prototype.addEventListener = function (type, listener) {
        this.listeners[type].push(listener);
    };
    Logger.prototype.removeEventListener = function (type, listener) {
        this.listeners[type] = this.listeners[type].filter(function (item) { return item !== listener; });
    };
    Logger.prototype.prepareRoot = function (nodeInfo) {
        var rootNode = this.createRootNode(nodeInfo);
        this.rootNodes.push(rootNode);
        return rootNode;
    };
    Logger.prototype.prepareChild = function (parent, nodeInfo) {
        var node = this.createChildNode(nodeInfo, parent);
        if (parent.flags.logged && !node.flags.logged) {
            this.appendToSubresult(node, parent);
        }
        return node;
    };
    Logger.prototype.attachNode = function (node) {
        var _this = this;
        node.flags.attached = true;
        this.markAttachedNodeAsCreated(node);
        if (node.flags.logged) {
            this.baobabSender.attachTree({
                node: this.encodeNode(node),
                eventData: {
                    cts: Date.now(),
                    triggerEvent: this.actualEvent || this.lastEvent,
                    triggerEventTrusted: Boolean(this.actualEvent),
                },
            });
        }
        else if (typings_1.isChildNode(node)) {
            setTimeout(function () { return _this.logChildNodes(node); }, 0);
        }
        else {
            this.markNodeAsLogged(node);
            this.baobabSender.createTree({
                node: this.encodeNode(node),
                eventData: {
                    cts: Date.now(),
                    triggerEvent: this.actualEvent || this.lastEvent,
                    triggerEventTrusted: Boolean(this.actualEvent),
                },
            }, function (sendInfo) {
                _this.listeners.createnode.forEach(function (listener) { return listener.call(_this, {
                    logger: _this,
                    target: node,
                    create: node,
                    on: null,
                    sendInfo: sendInfo,
                }); });
            });
        }
    };
    Logger.prototype.logChildNodes = function (node) {
        var _this = this;
        if (node.flags.logged)
            return;
        var parentId = node.parent.id;
        var createdSubresult = this.childrenCreatedPerLoop[parentId];
        if (!createdSubresult)
            return;
        this.childrenCreatedPerLoop[parentId] = undefined;
        createdSubresult.children.map(function (node) { return _this.markNodeAsLogged(node); });
        this.baobabSender.appendTree({
            node: this.encodeNode(createdSubresult),
            eventData: {
                cts: Date.now(),
                triggerEvent: this.actualEvent || this.lastEvent,
                triggerEventTrusted: Boolean(this.actualEvent),
            },
        }, function (sendInfo) {
            _this.listeners.createnode.forEach(function (listener) { return listener.call(_this, {
                logger: _this,
                target: node,
                create: createdSubresult,
                on: node.parent,
                sendInfo: sendInfo,
            }); });
        });
    };
    Logger.prototype.detachNode = function (node) {
        var _this = this;
        if (!node.flags.attached)
            return;
        node.flags.attached = false;
        this.markNodeAsDestroyed(node);
        this.baobabSender.detachTree({
            node: this.encodeNode(node),
            eventData: {
                cts: Date.now(),
                triggerEvent: this.actualEvent || this.lastEvent,
                triggerEventTrusted: Boolean(this.actualEvent),
            },
        }, function (sendInfo) {
            _this.listeners.removenode.forEach(function (listener) { return listener.call(_this, {
                logger: _this,
                target: node,
                remove: node,
                sendInfo: sendInfo,
                from: typings_1.isChildNode(node) ? node.parent : null,
            }); });
        });
    };
    Logger.prototype.dispatchEvent = function (node, event) {
        var _this = this;
        this.baobabSender.clientAction({ node: this.encodeNode(node), eventData: event }, function (sendInfo) {
            _this.listeners.actionnode.forEach(function (listener) { return listener.call(_this, {
                logger: _this,
                target: node,
                action: event,
                sendInfo: sendInfo,
            }); });
        });
    };
    Logger.prototype.logTechEventForRoot = function (type, data) {
        var rootNodes = this.getRootNodes();
        var node = rootNodes[rootNodes.length - 1];
        if (!node)
            throw new errors_1.BaobabNotInitError();
        var eventDeclaration = Baobab_EventConstruct_1.logTech(type, data);
        var event = this.createEvent(node, eventDeclaration, [], {});
        this.dispatchEvent(node, event);
    };
    Logger.prototype.createEvent = function (node, eventDeclaration, _eventArgs, _props) {
        var event = {
            cts: Date.now(),
            id: this.generateEventId(),
            event: eventDeclaration.event,
            data: eventDeclaration.data,
            service: node.context.service,
            subservice: node.context.subservice,
        };
        if (eventDeclaration.type)
            event.type = eventDeclaration.type;
        if (eventDeclaration.behaviour)
            event.behaviour = eventDeclaration.behaviour;
        return event;
    };
    Logger.prototype.withEvent = function (event, callback) {
        this.lastEvent = event;
        this.actualEvent = event;
        callback(this.resolveEvent);
    };
    Logger.prototype.encodeNode = function (node, parentIsHidden) {
        var _this = this;
        if (parentIsHidden === void 0) { parentIsHidden = false; }
        var logNode = {
            id: node.id,
            name: node.name,
        };
        var isHidden = !parentIsHidden && typings_1.isTreeNode(node) && !node.flags.attached;
        if (node.attrs && Object.keys(node.attrs).length) {
            logNode.attrs = node.attrs;
        }
        if (isHidden) {
            logNode.attrs = __assign(__assign({}, logNode.attrs), { hidden: true });
        }
        if (node.children.length) {
            logNode.children = node.children.map(function (child) { return _this.encodeNode(child, isHidden); });
        }
        return logNode;
    };
    Logger.prototype.generateEventId = function () {
        return Date.now().toString(36) + (this.nextEventId++).toString(36);
    };
    Logger.prototype.generateNodeId = function () {
        return this.prefix + (this.nextNodeId++).toString(36);
    };
    Logger.prototype.markAttachedNodeAsCreated = function (node) {
        var _this = this;
        if (!node.flags.attached)
            return;
        node.flags.created = true;
        node.children.forEach(function (subNode) { return _this.markAttachedNodeAsCreated(subNode); });
    };
    Logger.prototype.markNodeAsDestroyed = function (node) {
        var _this = this;
        node.flags.created = false;
        node.children.forEach(function (subNode) { return _this.markNodeAsDestroyed(subNode); });
    };
    Logger.prototype.markNodeAsLogged = function (node) {
        var _this = this;
        node.flags.logged = true;
        node.children.forEach(function (subNode) { return _this.markNodeAsLogged(subNode); });
    };
    Logger.prototype.appendToSubresult = function (node, parent) {
        var subResult = this.childrenCreatedPerLoop[parent.id];
        if (!subResult) {
            var subResult_1 = {
                id: this.generateNodeId(),
                name: '$subresult',
                attrs: {
                    'schema-ver': exports.SCHEMA_VER,
                    ui: node.context.ui,
                    subservice: node.context.subservice,
                    'parent-id': parent.id,
                    'trigger-event-id': this.actualEvent || this.lastEvent,
                    'trigger-event-trusted': Boolean(this.actualEvent),
                    'main-search': parent.context.subservice !== node.context.subservice,
                },
                children: [node],
            };
            this.childrenCreatedPerLoop[parent.id] = subResult_1;
            return subResult_1;
        }
        subResult.children.push(node);
        return subResult;
    };
    Logger.prototype.createChildNode = function (nodeInfo, parent) {
        var node = {
            key: nodeInfo.key,
            parent: parent,
            id: this.generateNodeId(),
            name: nodeInfo.name,
            attrs: nodeInfo.attrs,
            children: [],
            mapChildren: {},
            flags: {
                logged: false,
                created: true,
                attached: false,
            },
            context: this.createNodeContext(nodeInfo, parent),
        };
        parent.children.push(node);
        return node;
    };
    Logger.prototype.createRootNode = function (nodeInfo) {
        return {
            key: nodeInfo.key,
            id: this.generateNodeId(),
            name: nodeInfo.name,
            attrs: __assign({}, nodeInfo.attrs),
            children: [],
            mapChildren: {},
            flags: {
                logged: false,
                created: true,
                attached: false,
            },
            context: this.createRootContext(nodeInfo),
        };
    };
    Logger.prototype.createNodeContext = function (nodeInfo, parent) {
        var result = __assign(__assign({}, parent.context), { path: parent.context.path.concat(nodeInfo.name) });
        if (nodeInfo.attrs && nodeInfo.attrs.subservice)
            result.subservice = nodeInfo.attrs.subservice;
        return result;
    };
    Logger.prototype.createRootContext = function (nodeInfo) {
        var result = {
            path: [nodeInfo.name],
            service: nodeInfo.attrs.service,
            ui: nodeInfo.attrs.ui,
        };
        if (nodeInfo.attrs.subservice)
            result.subservice = nodeInfo.attrs.subservice;
        return result;
    };
    return Logger;
}());
exports.Logger = Logger;
